import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=7f80db4a&scoped=true&"
import script from "./collect.vue?vue&type=script&lang=js&"
export * from "./collect.vue?vue&type=script&lang=js&"
import style0 from "./collect.vue?vue&type=style&index=0&id=7f80db4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f80db4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f80db4a')) {
      api.createRecord('7f80db4a', component.options)
    } else {
      api.reload('7f80db4a', component.options)
    }
    module.hot.accept("./collect.vue?vue&type=template&id=7f80db4a&scoped=true&", function () {
      api.rerender('7f80db4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/channelCom/collect.vue"
export default component.exports